import React, { useState } from "react";
import ServiceLevelCard from "./ServiceLevelCard";
import FlightDetailsCard from "./FlightDetailsCard";
import FleetRateFilters from "./FleetRateFilters";
import { getUniqueVendorCount } from "./utils";
import { RATE_TYPES } from "./airportRatesUtils";
import { DirectionsCar, AccessTime, Straighten } from "@material-ui/icons";

const RateAnalysisResults = ({
  data,
  currency,
  searchSummary,
  airportDetails = [],
  loadingAirportDetails = false,
  tripType,
}) => {
  const [fleetFilters, setFleetFilters] = useState(null);

  if (!data) {
    return null;
  }

  const vendorCount = getUniqueVendorCount(data.fleetOffers);
  const defaultAirportCode =
    searchSummary?.airportCode ||
    data.flightDetails?.arrival?.airportCode ||
    data.flightDetails?.departure?.airportCode ||
    airportDetails[0]?.iata ||
    "";

  return (
    <div className="">
      
      <div className="bg-white main-section-spacing border-radius-8 rate-analysis-results">
        <div className="rate-analysis-results-header">
          <h2 className="font-16 font-600 m-0">Rate Comparison Results</h2>
          <p className="rate-analysis-results-subtitle">
            {data.fleetOffers.length} service levels found
            {vendorCount > 0 && ` across ${vendorCount} vendors`}
          </p>
        </div>

        {(searchSummary?.pickup || searchSummary?.dropoff) && (
          <div className="rate-analysis-trip-summary">
            <div className="rate-analysis-trip-route">
              <div className="rate-analysis-trip-point">
                <span className="rate-analysis-trip-dot rate-analysis-trip-dot-pickup" />
                <div>
                  <p className="rate-analysis-trip-label">Pickup</p>
                  <p className="rate-analysis-trip-address">
                    {searchSummary.pickup}
                  </p>
                </div>
              </div>
              <div className="rate-analysis-trip-line" />
              <div className="rate-analysis-trip-point">
                <span className="rate-analysis-trip-dot rate-analysis-trip-dot-dropoff" />
                <div>
                  <p className="rate-analysis-trip-label">Drop-off</p>
                  <p className="rate-analysis-trip-address">
                    {searchSummary.dropoff}
                  </p>
                </div>
              </div>
            </div>

            <div className="rate-analysis-trip-meta">
              {searchSummary.tripType && (
                <div className="rate-analysis-meta-item">
                  <span className="rate-analysis-meta-label">Trip type</span>
                  <span className="rate-analysis-meta-value">
                    {searchSummary.tripType}
                  </span>
                </div>
              )}
              {searchSummary.passengerCount > 0 && (
                <div className="rate-analysis-meta-item">
                  <span className="rate-analysis-meta-label">Passengers</span>
                  <span className="rate-analysis-meta-value">
                    {searchSummary.passengerCount}
                  </span>
                </div>
              )}
              {searchSummary.flightNumber && (
                <div className="rate-analysis-meta-item">
                  <span className="rate-analysis-meta-label">Flight</span>
                  <span className="rate-analysis-meta-value">
                    {searchSummary.flightNumber}
                  </span>
                </div>
              )}
              {searchSummary.date && (
                <div className="rate-analysis-meta-item">
                  <span className="rate-analysis-meta-label">
                    {searchSummary.flightNumber ? "Date" : "Date & time"}
                  </span>
                  <span className="rate-analysis-meta-value">
                    {searchSummary.date}
                  </span>
                </div>
              )}
            </div>
          </div>
        )}

        {data.routeSummary && (
          <div className="rate-analysis-route-stats">
            {data.routeSummary.estimatedDuration && (
              <div className="rate-analysis-route-stat">
                <AccessTime className="rate-analysis-route-stat-icon" />
                <div>
                  <p className="rate-analysis-route-stat-label">Duration</p>
                  <p className="rate-analysis-route-stat-value">
                    {data.routeSummary.estimatedDuration}
                  </p>
                </div>
              </div>
            )}
            {data.routeSummary.totalDistance && (
              <div className="rate-analysis-route-stat">
                <Straighten className="rate-analysis-route-stat-icon" />
                <div>
                  <p className="rate-analysis-route-stat-label">Distance</p>
                  <p className="rate-analysis-route-stat-value">
                    {data.routeSummary.totalDistance}
                  </p>
                </div>
              </div>
            )}
            <div className="rate-analysis-route-stat">
              <DirectionsCar className="rate-analysis-route-stat-icon" />
              <div>
                <p className="rate-analysis-route-stat-label">Fleet options</p>
                <p className="rate-analysis-route-stat-value">
                  {data.fleetOffers.length} tiers
                </p>
              </div>
            </div>
          </div>
        )}

        <FlightDetailsCard
          flightDetails={data.flightDetails}
          flightLandTime={data.flightLandTime}
        />
      </div>
   

      <div className="rate-analysis-fleet-section bg-white main-section-spacing border-radius-8 ">
        <div className="rate-analysis-fleet-toolbar">
          <h3 className="rate-analysis-fleet-heading">Available Fleet & Rates</h3>
          <FleetRateFilters
            airports={airportDetails}
            loadingAirports={loadingAirportDetails}
            defaultAirportCode={defaultAirportCode}
            onChange={setFleetFilters}
          />
        </div>

        {fleetFilters?.rateType === RATE_TYPES.FIXED && fleetFilters?.polygonId && (
          <p className="rate-analysis-fleet-filter-hint">
            Showing fixed rates for{" "}
            <strong>{fleetFilters.airportCode}</strong>
            {fleetFilters.polygonName && (
              <>
                {" "}
                — <strong>{fleetFilters.polygonName}</strong>
              </>
            )}
          </p>
        )}

        <div className="rate-analysis-service-list">
          {data.fleetOffers.map((offer) => (
            <ServiceLevelCard
              key={offer.offerKey || `${offer.categoryId}-${offer.tierName}`}
              offer={offer}
              currency={currency}
              fleetFilters={fleetFilters}
              airportDetails={airportDetails}
              tripType={tripType}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default RateAnalysisResults;
